import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { WebHookReceiverLogStateClass } from './interfaces/WebHookReceiverLogStateClass'
import { sortData } from '../../../common/timeLiveFunction'
import { start } from 'repl'

const initialState: WebHookReceiverLogStateClass = {
    isLoading: false,
    status: 'idle',
    WebHookReceiverLogList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    start: 0,
    search: " ",
    isSearch: false,
    ResponseBody: "",
    RequestURI: "",
    ActionDescription: "",
    checkedRecordsArray: [],
    isAllUnChecked: true,
    recordsFiltered: 0,
    WebHookReceiverLogCheckedIds: [],
    optionStatusValue: "All",
    optionStatusText: "All",
    optionWebHookEventTypeValue: "All",
    optionWebHookEventTypeText: "All",
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    columnIndex: 0,
    direction: "asc",
    pageNo: 1,
    startRec: 0,
    sortOrder: 'asc',
    sortColumn: '1',
    SearchParamsValues: "",
}
interface IThunkApi {
    state: {
        webHookReceiverLog: WebHookReceiverLogStateClass;
    },
}
/* export const getAccountWebHookReceiverLogAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHookReceiverLog/V2/getAccountWebHookReceiverLog',
        async (arg, thunkApi) => {
            const { pageNo, pageSize, startRec, sortColumn, sortOrder, SearchParamsValues, search } = thunkApi.getState().webHookReceiverLog;
            const response = await fetchAPI(`api/V2/Logs/GetWebhookReceiverLogDatatable/${pageNo}/${pageSize}/${startRec}/${sortColumn}/${sortOrder}/${SearchParamsValues}/${search}`, `Get`, '', true);
            const json = await response.json();
            return json;

        }
    ) */
    export const getAccountWebHookReceiverLogAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHookReceiverLog/V2/getAccountWebHookReceiverLog',
        async (arg, thunkApi) => {
            const { currentPage, pageSize, start, search, SearchParamsValues } = arg;
            const encodedCurrentPage = encodeURIComponent(currentPage);
            const encodedPageSize = encodeURIComponent(pageSize);
            const encodedStart = encodeURIComponent(start);
            const trimmedSearchParamsValues = SearchParamsValues.trim();
            const encodedSearchParamsValues = encodeURIComponent(trimmedSearchParamsValues);
            const trimmedSearch = search.trim();
            const encodedSearch = encodeURIComponent(trimmedSearch);

            const encodedData = {
                currentPage:currentPage,
                pageSize:pageSize,
                start:start,
                SearchParamsValues:trimmedSearchParamsValues,
                search: trimmedSearch
              };
            const response = await fetchAPI(
                'api/V2/Logs/GetWebhookReceiverLogDatatable/'+SearchParamsValues,
                'POST',
                encodedData,
                true,
                '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab'
            );
            const json = await response.json();
            return json;
        }
    )
export const getWebHookReceiverLogAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHookReceiverLog/V2/getWebHookReceiverLog',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Logs/WebHookReceiver/' + arg, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const getWebhookRetryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHookReceiverLog/V2/getWebhookRetry',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Logs/Retry?SearchParamsValues=' + arg, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const webHookReceiverLogSlice = createSlice({
    name: 'webHookReceiverLog',
    initialState,
    reducers: {
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.WebHookReceiverLogList;
            state.WebHookReceiverLogList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        },
        updateSorting1: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
        },
        resetSelectedRecordObjectInState: (state) => {
            state.WebHookReceiverLogList = [];
            state.WebHookReceiverLogCheckedIds = [];

        },
        checkedState: (state, action) => {
            const currentindex = state.WebHookReceiverLogList.findIndex((item) => item.AccountWebhookReceiverLogId == action.payload);
            const newArray = [...state.WebHookReceiverLogList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.WebHookReceiverLogList = newArray;
            state.isAllUnChecked = false;
            state.WebHookReceiverLogCheckedIds.push(newArray[currentindex].AccountWebhookReceiverLogId);
        },
        unCheckedState: (state, action) => {
            const currentindex = state.WebHookReceiverLogList.findIndex((item) => item.AccountWebhookReceiverLogId == action.payload);
            const newArray = [...state.WebHookReceiverLogList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.WebHookReceiverLogList = newArray;
            state.WebHookReceiverLogCheckedIds = state.WebHookReceiverLogCheckedIds.filter(item => item !== newArray[currentindex].AccountWebhookReceiverLogId);
        },
        checkedAllState: (state) => {
            const newArray = state.WebHookReceiverLogList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.WebHookReceiverLogList = newArray;
            state.isAllUnChecked = false;
            state.WebHookReceiverLogList.map((i) => {
                if (!state.WebHookReceiverLogCheckedIds.includes(i.AccountWebhookReceiverLogId) && i.StatusCode !== 200 && i.StatusCode !== 202) {
                    state.WebHookReceiverLogCheckedIds.push(i.AccountWebhookReceiverLogId)
                }
            });
        },
        unCheckedAllState: (state) => {
            const newArray = state.WebHookReceiverLogList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.WebHookReceiverLogList = newArray;
            state.isAllUnChecked = true;
            state.WebHookReceiverLogList.map((i) => (
                state.WebHookReceiverLogCheckedIds = state.WebHookReceiverLogCheckedIds.filter(item => item !== i.AccountWebhookReceiverLogId)
            ));
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            state.isAllUnChecked = state.WebHookReceiverLogList.every((item) => item.isSelected === 0);
        },
        setOptionStatusValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionStatusValue = value;
            state.optionStatusText = label;
        },
        setOptionWebHookEventTypeValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionWebHookEventTypeValue = value;
            state.optionWebHookEventTypeText = label;
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        setSortConfig: (state, action) => {
            const { columnIndex, direction } = action.payload;


            let ndirection = 'asc';
            if (state.columnIndex === columnIndex && state.direction === 'asc') {
                ndirection = 'desc';

            }

            state.direction = ndirection;

            state.columnIndex = columnIndex;

        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;

        },
        setSearchValue: (state, action) => {

            state.search = action.payload;
            state.currentPage = 1;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountWebHookReceiverLogAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            // .addCase(getAccountWebHookReceiverLogAsync.fulfilled, (state, { payload }) => {
            //     state.status = 'idle';
            //     console.log("Testing", payload)
            //    if (payload.Data.data !== undefined) {
            //     // if (payload.Data.length > 0) {
            //         // state.WebHookReceiverLogList = JSON.parse(payload.Data.data);
            //         state.WebHookReceiverLogList = Array.isArray(payload.Data.data) ? payload.Data.data : JSON.parse(payload.Data.data || '[]');

            //         state.WebHookReceiverLogList.map((item: any) => {
            //             if(state.WebHookReceiverLogCheckedIds.includes(item.AccountWebhookReceiverLogId))
            //             {
            //                 item.isSelected = 1
            //             }
            //             else
            //             {
            //                 item.isSelected = 0
            //             }    
            //         });

            //         state.selectedRecord = {};
            //         state.pageNo = payload.Data.currentPage;
            //         state.startRec = payload.Data.start
            //         state.totalItems = payload.Data.recordsTotal;
            //         state.search = payload.Data.search;
            //         state.isReload = false;
            //         state.recordsFiltered = payload.Data.recordsFiltered;
            //         state.isSearch = false;
            //         state.isLoading = false;
            //         state.pageSize = payload.Data.pageSize;
            //     }
            // })
            .addCase(getAccountWebHookReceiverLogAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false; // Set isLoading to false when request is fulfilled
    
                if (payload.data !== undefined) {
                    state.WebHookReceiverLogList = JSON.parse(payload.data);
    
                    state.WebHookReceiverLogList.forEach((item: any) => {
                        
                    });
    
                    state.isReload = false;
                    state.selectedRecord = {};
                    state.currentPage = payload.currentPage;
                    state.start = payload.start;
                    state.totalItems = payload.recordsTotal;
                    state.search = payload.search;
                    state.recordsFiltered = payload.recordsFiltered;
                    state.WebHookReceiverLogList.map((item: any) => {
                                     if(state.WebHookReceiverLogCheckedIds.includes(item.AccountWebhookReceiverLogId))
                                     {
                                         item.isSelected = 1
                                     }
                                     else
                                     {
                                         item.isSelected = 0
                                     }    
                                 });
                }
            })
            .addCase(getAccountWebHookReceiverLogAsync.rejected, (state) => {
                state.status = 'failed';

                state.isLoading = false;
            })
            .addCase(getWebHookReceiverLogAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getWebHookReceiverLogAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.ResponseBody = JSON.parse(payload.Data.ResponseBody);
                state.RequestURI = payload.Data.RequestURI;
                state.ActionDescription = payload.Data.ActionDescription;
            })
            .addCase(getWebHookReceiverLogAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getWebhookRetryAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getWebhookRetryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;

            })
            .addCase(getWebhookRetryAsync.rejected, (state) => {
                state.status = 'failed';
            })


    }
})

export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState, updatePagination, updateSearchPagination, updateSorting,
    setDateRangeValue, setOptionStatusValue, setOptionWebHookEventTypeValue, setSortConfig, setPageSize, setSearchValue
} = webHookReceiverLogSlice.actions
export const WebHookReceiverLogState = (state: RootState) => state.webHookReceiverLog
export default webHookReceiverLogSlice.reducer
